// components/Dashboard.jsx
import React, { useState } from 'react';
import {
     Plane, FileText, CreditCard,
    Hotel, Package, HelpCircle, Shield,Car,
    ArrowUpRight,
    ArrowDownRight,
    Map
} from 'lucide-react';
import SidebarAdmin from './superdashboard/SideBarAdmin';
import MobileNavigationAdmin from './superdashboard/MobileNavigationAdmin';
import DashboardHeaderAdmin from './superdashboard/DashboardHeaderAdmin';
import StatAdminCard from './superdashboard/StatAdminCard';
import useGlobale from './../components/global';
import Statistics from './Satistiques';
import WeeklyChart from './WeeklyCard';
import AdminMenu from '../components/AdminMenu';
import TravelStatistics from './superdashboard/Statistisques';

const DashboardAdmin = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const { user } = useGlobale();

   
   // Configuration des statistiques pour les autorités
   const stats = [
    {
        title: 'Entrées au Niger',
        value: '1,247',
        icon: <ArrowDownRight className="w-6 h-6 text-white" />,
        change: '+18% ce mois',
        bgColor: 'from-brand-500 to-brand-600',
        info: 'Voyageurs entrés sur le territoire'
    },
    {
        title: 'Sorties du Niger',
        value: '985',
        icon: <ArrowUpRight className="w-6 h-6 text-white" />,
        change: '+12% ce mois',
        bgColor: 'from-green-600 to-green-700',
        info: 'Voyageurs ayant quitté le territoire'
    },
    {
        title: 'Voyages Internes',
        value: '2,365',
        icon: <Map className="w-6 h-6 text-white" />,
        change: '8 régions actives',
        bgColor: 'from-brand-500 to-brand-600',
        info: 'Déplacements inter-régions'
    },
    {
        title: 'Total Voyages',
        value: '4,597',
        icon: <Plane className="w-6 h-6 text-white" />,
        change: '+15% ce mois',
        bgColor: 'from-green-600 to-green-700',
        info: 'Tous types de voyages confondus'
    }
];

    // Configuration des actions rapides
    const quickActions = [
        { icon: <Plane />, label: 'Nouveau Voyage', path: '/procedure' },
        { icon: <Hotel />, label: 'Réserver Hôtel' },
        { icon: <Package />, label: 'Mes Bagages' },
        { icon: <HelpCircle />, label: 'Support' }
    ];

    // Configuration des documents
    const documentAlerts = [
        {
            type: 'Passeport',
            expiration: '2024-12-31',
            status: 'Valide',
            icon: <FileText className="w-4 h-4" />
        },
        {
            type: 'Visa',
            expiration: '2024-06-15',
            status: 'À renouveler',
            icon: <FileText className="w-4 h-4" />
        },
        {
            type: 'Assurance',
            expiration: '2024-09-30',
            status: 'Valide',
            icon: <Shield className="w-4 h-4" />
        }
    ];

    return (
        <div className="flex min-h-screen bg-[#F4F8E9]">
            <SidebarAdmin
                isOpen={isSidebarOpen}
                menuItems={AdminMenu}
                onClose={() => setIsSidebarOpen(false)}
            />

            <div className="flex-1">
                <DashboardHeaderAdmin
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}
                    user={user}
                />

                <main className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-8 pb-20 lg:pb-8">
                    {/* Welcome Section */}
                    <div className="mb-8">
                        <h1 className="text-2xl font-bold text-[#437011]">
                            Bienvenue, {user.first_name} {user.last_name}👋
                        </h1>
                        {/* <p className="text-gray-600">
                            Voici un aperçu de vos activités de voyage
                        </p> */}
                    </div>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8">
                        {stats.map((stat, index) => (
                            <StatAdminCard key={index} {...stat} />
                        ))}
                    </div>
                  
                    <TravelStatistics />
                    <Statistics />
                    <WeeklyChart />
                </main>
                <MobileNavigationAdmin menuItems={AdminMenu} />
            </div>
        </div>
    );
};

export default DashboardAdmin;